import { render, staticRenderFns } from "./EducationalConcept.vue?vue&type=template&id=e5067232&scoped=true&"
import script from "./EducationalConcept.vue?vue&type=script&lang=js&"
export * from "./EducationalConcept.vue?vue&type=script&lang=js&"
import style0 from "./EducationalConcept.vue?vue&type=style&index=0&id=e5067232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5067232",
  null
  
)

export default component.exports